import { useId } from 'react';

import { CircleHelpIcon } from 'lucide-react';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface ReadOnlyFieldProps {
  label?: string;
  value?: string | number | null;
  className?: string;
  /** Overrides the muted label, e.g. to match editable fields beside it. */
  labelClassName?: string;
  isLoading?: boolean;
  tooltip?: string;
}

export const ReadOnlyField = ({
  label,
  value,
  className,
  labelClassName,
  isLoading,
  tooltip,
}: ReadOnlyFieldProps) => {
  const inputId = useId();

  return (
    <div className={cn('space-y-1', className)}>
      {label && (
        <Label htmlFor={inputId} className={cn('text-foreground-muted', labelClassName)}>
          {label}
          {tooltip && (
            <InfoTooltip content={tooltip} side="right">
              <CircleHelpIcon size={12} className="text-foreground-muted" />
            </InfoTooltip>
          )}
        </Label>
      )}
      {isLoading ? (
        <Skeleton className="h-10 w-full" />
      ) : (
        <Input
          id={inputId}
          readOnly
          value={value ?? ''}
          className="bg-bg-muted-50 text-foreground-muted focus-visible:ring-0 focus-visible:ring-offset-0"
        />
      )}
    </div>
  );
};
